import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="xmpdatetime" id="xmpdatetime"></a>
    <h1 {...{
      "id": "requireuxpxmpxmpdatetime"
    }}>{`require('uxp').xmp.XMPDateTime`}</h1>
    <p><strong parentName="p">{`Since`}</strong>{`: v7.2.0  `}</p>
    <a name="new-xmpdatetime-new" id="new-xmpdatetime-new"></a>
    <h2 {...{
      "id": "xmpdatetime"
    }}>{`XMPDateTime()`}</h2>
    <p>{`XMPDateTime class represents a date and time.
XMP's time includes time zone, and can have up to nanosecond resolution.`}</p>
    <a name="new-xmpdatetime-new" id="new-xmpdatetime-new"></a>
    <h2 {...{
      "id": "xmpdatetimedate"
    }}>{`XMPDateTime(date)`}</h2>
    <p>{`Create XMPDateTime`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`date`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Date`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`[Optional]`}</inlineCode>{`                  `}<inlineCode parentName="td">{`Date`}</inlineCode>{` : A JavaScript Date object. The time zone is set to the local operation-system time-zone value.                         Time can have up to nanosecond resolution; however, when converting to or from a JavaScript Date value,                         time resolution is reduced to milliseconds.`}<br></br>{`                  `}<inlineCode parentName="td">{`iso8601Date`}</inlineCode>{`: A string containing a date-time in ISO 8601 format; for example: "2007-04-10T17:54:50+01:00"`}</td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Below example demonstrates how to create XMPDateTime
// Importing XMPDateTime class
const { XMPDateTime } = require("uxp").xmp;

// 1. Creating using Date object
const xdt1 = new XMPDateTime(new Date());

// 2. Creating using iso8601Date
const xdt2 = new XMPDateTime("2007-04-10T17:54:50+01:00");

// 3.  Creating with no arguments
const xdt3 = new XMPDateTime();
`}</code></pre>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`// Below example demonstrates how to compare two XMPDateTime objects
// Importing XMPDateTime class
const { XMPDateTime } = require("uxp").xmp;

const currentDate = new XMPDateTime(new Date());

const oldDate = new XMPDateTime("2007-04-10T17:54:50+01:00");

currentDate.compareTo(oldDate);
// Returns 1

oldDate.compareTo(currentDate);
// Returns -1

currentDate.compareTo(currentDate);
// Returns 0
`}</code></pre>
    <a name="xmpdatetime-year" id="xmpdatetime-year"></a>
    <h2 {...{
      "id": "year--number"
    }}>{`year : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The year, in the range `}{`[0000…9999]`}{`.`}</p>
    <a name="xmpdatetime-month" id="xmpdatetime-month"></a>
    <h2 {...{
      "id": "month--number"
    }}>{`month : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The month, in the range `}{`[1…12]`}{`.`}</p>
    <a name="xmpdatetime-day" id="xmpdatetime-day"></a>
    <h2 {...{
      "id": "day--number"
    }}>{`day : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The day, in the range `}{`[1…31]`}{`.`}</p>
    <a name="xmpdatetime-hour" id="xmpdatetime-hour"></a>
    <h2 {...{
      "id": "hour--number"
    }}>{`hour : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The hour, in the range `}{`[1…23]`}{`.`}</p>
    <a name="xmpdatetime-minute" id="xmpdatetime-minute"></a>
    <h2 {...{
      "id": "minute--number"
    }}>{`minute : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The minute, in the range `}{`[1…59]`}{`.`}</p>
    <a name="xmpdatetime-second" id="xmpdatetime-second"></a>
    <h2 {...{
      "id": "second--number"
    }}>{`second : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The second, in the range `}{`[1…59]`}{`.`}</p>
    <a name="xmpdatetime-nanosecond" id="xmpdatetime-nanosecond"></a>
    <h2 {...{
      "id": "nanosecond--number"
    }}>{`nanosecond : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The nanosecond, in the range `}{`[0…1e+9 -1]`}{`.`}</p>
    <a name="xmpdatetime-tzsign" id="xmpdatetime-tzsign"></a>
    <h2 {...{
      "id": "tzsign--number"
    }}>{`tzSign : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The time zone direction of offset. - 0: UTC - -1: west - 1: east`}</p>
    <a name="xmpdatetime-tzhour" id="xmpdatetime-tzhour"></a>
    <h2 {...{
      "id": "tzhour--number"
    }}>{`tzHour : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The time zone hour offset from the prime meridian, in the range `}{`[1…23]`}{`.`}</p>
    <a name="xmpdatetime-tzminute" id="xmpdatetime-tzminute"></a>
    <h2 {...{
      "id": "tzminute--number"
    }}>{`tzMinute : `}<inlineCode parentName="h2">{`number`}</inlineCode></h2>
    <p>{`The time zone minute offset from the prime meridian, in the range `}{`[1…59]`}{`.`}</p>
    <a name="xmpdatetime-compareto" id="xmpdatetime-compareto"></a>
    <h2 {...{
      "id": "comparetodatetime"
    }}>{`compareTo(dateTime)`}</h2>
    <p>{`Reports the time order of two date-time values.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`number`}</inlineCode>{` - 0 if the two values are the same,`}<br></br>{`
1 if this date-time is later than the comparison value,`}<br></br>{`
-1 if this date-time is earlier than the comparison value.`}<br></br><inlineCode parentName="p">{`number`}</inlineCode>{`  `}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`dateTime`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`XMPDateTime`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Another XMPDateTime object.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="xmpdatetime-converttolocaltime" id="xmpdatetime-converttolocaltime"></a>
    <h2 {...{
      "id": "converttolocaltime"
    }}>{`convertToLocalTime()`}</h2>
    <p>{`Sets the time zone in this object to the local operating-system time zone,
adjusting the time values from the previous time zone, if necessary.`}</p>
    <a name="xmpdatetime-converttoutctime" id="xmpdatetime-converttoutctime"></a>
    <h2 {...{
      "id": "converttoutctime"
    }}>{`convertToUTCTime()`}</h2>
    <p>{`Sets the time zone in this object to UTC (coordinated universal time),
adjusting the time values from the previous time zone, if necessary.`}</p>
    <a name="xmpdatetime-getdate" id="xmpdatetime-getdate"></a>
    <h2 {...{
      "id": "getdate"
    }}>{`getDate()`}</h2>
    <p>{`Converts this date-time value to a JavaScript Date. The time zone is normalized
(time zones are not supported in the JavaScript format), and the accuracy is reduced to milliseconds.`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`Date`}</inlineCode>{`  `}</p>
    <a name="xmpdatetime-setlocaltimezone" id="xmpdatetime-setlocaltimezone"></a>
    <h2 {...{
      "id": "setlocaltimezone"
    }}>{`setLocalTimeZone()`}</h2>
    <p>{`Sets the time zone in this object to the current operation-system value,
replacing any existing value. Does not affect other fields.`}</p>
    <a name="xmpdatetime-hasdate" id="xmpdatetime-hasdate"></a>
    <h2 {...{
      "id": "hasdate"
    }}>{`hasDate()`}</h2>
    <p>{`To check if the date is available`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{`  `}</p>
    <a name="xmpdatetime-hastime" id="xmpdatetime-hastime"></a>
    <h2 {...{
      "id": "hastime"
    }}>{`hasTime()`}</h2>
    <p>{`To check if time is available`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{`  `}</p>
    <a name="xmpdatetime-hastimezone" id="xmpdatetime-hastimezone"></a>
    <h2 {...{
      "id": "hastimezone"
    }}>{`hasTimeZone()`}</h2>
    <p>{`To check if timezone is available`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`boolean`}</inlineCode>{`  `}</p>
    <a name="xmpdatetime-tostring" id="xmpdatetime-tostring"></a>
    <h2 {...{
      "id": "tostring"
    }}>{`toString()`}</h2>
    <p>{`To get the string value of the object`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{`  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      